import {
  HttpClient,
  HttpContext,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { ApiResponse } from '@core/models';
import { environment } from '@environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';
import { ApiResponseError } from '../models/api-response.model';
import { ProvenueErrorService } from './provenue-error.service';

export class ApiException extends Error {
  public code: ApiResponseError['code'];
  public data: ApiResponseError['data'];

  constructor(error: ApiResponseError) {
    super();
    this.message = error?.message;
    this.code = error?.code;
    this.data = error?.data;
  }
}

export class BaseConnectionService {
  #provenueErrorService = inject(ProvenueErrorService);

  apiURL: string = environment.apiUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': `application/json`,
    }),
  };

  protected handleApiResponse<T>(
    observable: Observable<ApiResponse<T>>
  ): Observable<ApiResponse<T>> {
    return observable.pipe(
      map(obj => {
        if (obj.error) {
          throw new ApiException(obj.error);
        }

        return obj;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('API ERROR: ', error);
        const pvRequestId = error?.headers.get('pv-Request-Id');
        const pvProxyRequestId = error?.headers.get('pv-Proxy-Request-Id');
        this.#provenueErrorService.setPvRequestId(pvRequestId);
        this.#provenueErrorService.setPvProxyRequestId(pvProxyRequestId);
        this.#provenueErrorService.logProvenueIds();
        return throwError(() => new ApiException(error.error.error));
      })
    );
  }

  protected sendRequest<T>(
    http: HttpClient,
    endpoint: string,
    body: any = null,
    context?: HttpContext
  ) {
    const finalUrl = `${endpoint}`;
    const options = context
      ? { ...this.httpOptions, context }
      : this.httpOptions;
    const observable = body
      ? http.post<ApiResponse<T>>(finalUrl, body, options)
      : http.get<ApiResponse<T>>(finalUrl, options);
    return this.handleApiResponse(observable);
  }
}
